// import React from "react"
import DryMenu from "@bufox/dry-menu"
import styled from "styled-components"

const ThemeMenu = styled(DryMenu)`
  @media only screen and (max-width: ${props => {
      return `${props.lgScreen.replace("px", "") - 1}px`
    }}) {
    .auxiliary-nav {
      li {
        &:after {
          border: 1px solid var(--tertiary);
        }
      }
    }
    .toggle-submenu-button {
      color: var(--gray5);
    }
  }
  @media only screen and (min-width: ${props => props.lgScreen}) {
    .menu-level-1 {
      ul {
        background: var(--gray1);
        color: var(--primary);
      }
      > .entry {
        &:hover {
          > a {
            color: var(--gray4);
          }
          > ul {
            /* Track */
            ::-webkit-scrollbar-track {
              background: var(--gray1);
            }

            /* Handle */
            ::-webkit-scrollbar-thumb {
              background: var(--gray3);
            }
          }
        }
        &:after {
          background-color: var(--secondary);
        }
      }
    }
  }
`

export default ThemeMenu
